"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AssignEmployeesBody () {
        return AssignEmployeesBody;
    },
    get CheckRoleNameQuery () {
        return CheckRoleNameQuery;
    },
    get CreateRoleBody () {
        return CreateRoleBody;
    },
    get ListRoleEmployeesQuery () {
        return ListRoleEmployeesQuery;
    },
    get ListRoleOptionsQuery () {
        return ListRoleOptionsQuery;
    },
    get ListRolesQuery () {
        return ListRolesQuery;
    },
    get PatchRoleCompetencyBody () {
        return PatchRoleCompetencyBody;
    },
    get RoleSortBySchema () {
        return RoleSortBySchema;
    },
    get UpdateRoleBody () {
        return UpdateRoleBody;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../base");
const _constants = require("./constants");
const RoleSortBySchema = _zod.z.enum([
    "name",
    "description",
    "status",
    "employees_count",
    "competencies_count"
]);
const ListRolesQuery = _zod.z.object({
    name: _zod.z.string().optional(),
    status: (0, _base.createStatusFilterSchema)([
        "active",
        "archived"
    ]),
    sortBy: RoleSortBySchema.default("name"),
    sortOrder: _zod.z.enum([
        "asc",
        "desc"
    ]).default("asc"),
    limit: _zod.z.coerce.number().int().min(1).max(500).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0)
});
const ListRoleOptionsQuery = _zod.z.object({
    name: _zod.z.string().optional(),
    limit: _zod.z.coerce.number().int().min(1).max(500).default(100),
    skip: _zod.z.coerce.number().int().min(0).default(0),
    // Comma-separated role ids for resolving saved-filter labels; when present the handler matches
    // these ids (archived included) instead of the active-only name search.
    ids: _zod.z.preprocess((val)=>typeof val === "string" ? val.split(",").filter(Boolean) : val, _zod.z.array(_utilsisomorphic.transformObjectId)).optional()
});
const RoleCompetencyEntryRequest = _zod.z.object({
    competency_id: _utilsisomorphic.transformObjectId,
    expected_level: _zod.z.number().int().min(1).max(_models.MAX_COMPETENCY_LEVELS).nullable().default(null)
});
// Trim BEFORE validating min(1) — z.string().min(1).trim() leaves whitespace-only strings as
// valid (length 3 passes min(1), then trim collapses to ""). Pipe ensures min/max see the
// trimmed value.
const TrimmedRoleName = _zod.z.string().trim().pipe(_zod.z.string().min(1).max(_models.MAX_ROLE_NAME_LENGTH));
const CheckRoleNameQuery = _zod.z.object({
    name: TrimmedRoleName,
    excludeId: _utilsisomorphic.transformObjectId.optional()
});
const CreateRoleBody = _zod.z.object({
    name: TrimmedRoleName,
    description: _zod.z.string().max(_constants.MAX_ROLE_DESCRIPTION_LENGTH).default(""),
    competencies: _zod.z.array(RoleCompetencyEntryRequest).default([])
});
const UpdateRoleBody = _zod.z.object({
    name: TrimmedRoleName.optional(),
    description: _zod.z.string().max(_constants.MAX_ROLE_DESCRIPTION_LENGTH).optional(),
    competencies: _zod.z.array(RoleCompetencyEntryRequest).optional()
});
const PatchRoleCompetencyBody = _zod.z.discriminatedUnion("op", [
    _zod.z.object({
        op: _zod.z.literal("upsert"),
        competency_id: _utilsisomorphic.transformObjectId,
        expected_level: _zod.z.number().int().min(1).max(_models.MAX_COMPETENCY_LEVELS).nullable().default(null)
    }),
    _zod.z.object({
        op: _zod.z.literal("remove"),
        competency_id: _utilsisomorphic.transformObjectId
    })
]);
const AssignEmployeesBody = _zod.z.object({
    user_ids: _zod.z.array(_utilsisomorphic.transformObjectId).min(1)
});
const ListRoleEmployeesQuery = _zod.z.object({
    search: _zod.z.string().optional(),
    limit: _zod.z.coerce.number().int().min(1).max(500).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0)
});
